export default {
    "image": {
        "insert": "Insertar Imagen en",
        "url": "URL imagen",
        "alt": "Texto alternativo",
        "tooltip": "Insertar imagen",
        "options":{
            "url": "URL",
            "file":"Subir Archivo"
        },
        "file":"Subir Archivo",
        "preview":"Previsualización",
        "caption":"Introduce Subtítulo...",
        "delete":"Eliminar imagen",
    },
    "align": {
        "title": "Alinear",
        "left": "Alinear a la izquierda",
        "center": "Alinear al centro",
        "right": "Alinear a la derecha",
        "justify": "Justificado",
        "outdent": "Indentar a la izquierda",
        "indent": "Indentar a la derecha"
    },
    "block": {
        "title": "Bloque de texto",
        "normal": "Normal",
        "large": "Encabezado grande",
        "small": "Encabezado pequeño",
        "bullet": "Lista de viñetas",
        "numbered": "Lista numerada",
        "quote": "Cita",
        "code": "Código",
        "codeLanguages": "Lenguajes de código"
    },
    "format": {
        "title": "Formato de texto",
        "subscript": "Subíndice",
        "superscript": "Superíndice",
        "underline": "Subrayado",
        "strikethrough": "Tachado",
        "bold": "Negrita",
        "italic": "Itálica",
        "uppercase":"Mayúscula",
        "lowercase":"Minúscula",
        "capitalize":"Capitalizar"
    },
    "video":{
        "insert":"Insertar Video de Youtube en",
        "url": "URL del Video",

    },
    "excalidraw":{
        "discardMessage":"Estas seguro de que quieres descartar los cambios?",
        "cancel":"Cancelar",
        "insert":"Insertar",
    },
    "fontSizeOptions":{
        "increaseFontSize":"Incrementar Tamaño de Fuente",
        "decreaseFontSize":"Reducir Tamaño de Fuente"
    },
    "fontFamily": "Fuente de texto",
    "fontSize": "Tamaño",
    "title": "Texto enriquecido",
    "placeholder": "Introduce un texto...",
    "link": "Insertar link",
    "undo": "Deshacer",
    "redo": "Rehacer",
    "fontColor": "Color de letra",
    "backgroundColor": "Color de resalte",
    "language":"Idioma actual:",
    "dropdownItems":{
        "insert":"Insertar",
        "insertHorizontalLine":"Linea Horizontal",
        "insertImage":"Imagen",
        "collapsibleContainer":"Contenedor plegable",
        "excalidraw":"Excalidraw",
        "youtube":"Youtube"
    },
    "richTextCloseConfirmTitle":"¿Quieres cerrar el editor de Texto Enriquecido?",
    "richTextCloseConfirmWarning":"Si se cierra, los cambios no se guardarán"
};